import logo from './logo.jpeg';
import './App.css';
import Portfolio from './components/Portfolio';

function App() {
  return (
    <div className="App">
      <Portfolio></Portfolio>
    </div>
  );
}

export default App;
